module.exports = __webpack_public_path__ + "static/media/user-chart.ef84948e.svg";